import Progress from "@/components/common/Progress";
import { useTran } from "@/hooks";

const SurveyTakeHeader = ({
  title,
  description,
  currentStep = 1,
  totalSteps = 1,
  category = "common",
  stepQuestions = 0,
  answeredQuestions = 0,
  totalQuestions = 0,
  progressPercent = 0,
  progress = 0,
}) => {
  const { t } = useTran();
  const safePercent = Number.isFinite(progressPercent)
    ? Math.min(100, Math.max(0, progressPercent))
    : 0;
  const barPercent = Number.isFinite(progress)
    ? Math.min(100, Math.max(0, progress))
    : safePercent;
  return (
    <div className="flex flex-col gap-2">
      <div>
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        {description ? (
          <p className="text-xs text-muted-foreground">{description}</p>
        ) : null}
      </div>
      <div className="flex flex-wrap items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-muted-foreground">
        <span>
          {t("Step {{current}}/{{total}}", {
            current: currentStep,
            total: totalSteps,
          })}
        </span>
        <span>•</span>
        <span>{t(category)}</span>
        <span>•</span>
        <span>{t("{{count}}q", { count: stepQuestions })}</span>
        <span>•</span>
        <span>
          {t("Answered {{answered}}/{{total}}", {
            answered: answeredQuestions,
            total: totalQuestions,
          })}
        </span>
        <span>•</span>
        <span>{t("{{percent}}% complete", { percent: safePercent })}</span>
      </div>
      <Progress value={barPercent} />
      <div></div>
    </div>
  );
};

export default SurveyTakeHeader;
